import Link from 'next/link'
import Icon from '@components/shared/Icon'
import { postLink } from '@components/blog/utils/postLinks'
import useT from '@hooks/useTranslation'

import styles from '@components/blog/styles/PostNavigation.module.css'

function PostNavigation ({ prevArticle, nextArticle }) {
    if (!prevArticle && !nextArticle) return null

    const prevLink = prevArticle && postLink(prevArticle)
    const nextLink = nextArticle && postLink(nextArticle)

    return (
        <nav className={styles.navi}>
            { prevLink && postNavLink(prevLink, icon(['i:chevron_left', useT('Poprzedni post')]))}
            { nextLink && postNavLink(nextLink, icon([useT('Następny post'), 'i:chevron_right']))}
        </nav>
    )
}

function postNavLink (to, name) {
    return <Link href={to}><a>{ name }</a></Link>
}

function icon (stringArray) {
    return (
        <span>
            {
                stringArray.map(str => str.startsWith('i:')
                    ? <Icon key={str}>{ str.slice(2) }</Icon>
                    : <span key={str}>{ str }</span>
                )
            }
        </span>
    )
}

export default PostNavigation